import React, { useEffect, useRef } from "react";
import styled from "styled-components";
import { Colors } from "../../ColorConstants";
import { Text } from "../../TextConstants";
import CartProducts, { AquaCartProducts } from "./AddedProducts";

const ProductDetails = ({
  cartData,
  data,
  onDelete,
  onSubtract,
  onAdd,
  onContinueShopping,
  isAqua,
  hasSpinPromo,
  products,
  onAddWristBandItem,
}) => {
  const productDertailRef = useRef(null);

  const scrollToCard = () => {
    productDertailRef.current?.scrollIntoView({
      behavior: "smooth",
      block: "start",
    });
  };

  useEffect(() => {
    scrollToCard();
  }, []);

  return (
    <ProductDetailMainContainer ref={productDertailRef}>
      <ProductHeaderContainer>
        <ProductHeader>
          <ProductTitles>{Text.productDetails}</ProductTitles>
          {isAqua && <ProductTitles>{"Slot"}</ProductTitles>}
          <ProductTitles>{Text.price}</ProductTitles>
          {!isAqua && <ProductTitles>{Text.quantity}</ProductTitles>}
          <ProductTitles>{Text.subTotal}</ProductTitles>
        </ProductHeader>
      </ProductHeaderContainer>
      <ProductDetailContainer>
        {isAqua ? (
          <ProductDetail>
            {data?.map((item, index) => (
              <AquaCartProducts item={item} key={index} onDelete={onDelete} />
            ))}
            <AddItemsContainer>
              <AddItemsButton onClick={onContinueShopping}>
                <ButtonTitle>{Text.addMoreItems}</ButtonTitle>
              </AddItemsButton>
            </AddItemsContainer>
          </ProductDetail>
        ) : (
          <ProductDetail>
            {data?.map((item, index) => (
              <CartProducts
                item={item}
                key={index}
                onAdd={onAdd}
                onSubtract={onSubtract}
                onDelete={onDelete}
              />
            ))}
            {!hasSpinPromo && (
              <AddItemsContainer>
                  {products.length > 0 ? (
                <div style={{ display: "flex", gap: "8px" }}>
                  <div>
                    <img src={require("../../assets/images/wrist-band.png")} />
                  </div>
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        justifyContent: "space-between",
                        paddingBottom: "8px",
                      }}
                    >
                      <div style={{ fontWeight: 800, color: Colors.arsenic }}>
                        Add credits to your wristband
                      </div>
                      <div
                        style={{
                          display: "flex",
                          flexDirection: "row",
                          gap: "8px",
                        }}
                      >
                        {products.map((product) => (
                          <div
                            onClick={() => onAddWristBandItem(product)}
                            style={{
                              fontWeight: 800,
                              color: Colors.white,
                              background: Colors.aqua,
                              display: "flex",
                              alignItems: "center",
                              gap: "32px",
                              padding: "8px",
                              borderRadius: "8px",
                              border:
                                product.qty === 0
                                  ? "3px solid red"
                                  : "3px solid green",
                            }}
                          >
                            QAR {product.price}
                            <img
                              src={require("../../assets/icons/money-add.png")}
                              style={{ width: "24px" }}
                            />
                          </div>
                        ))}
                      </div>
                    </div>
                </div>
                  ):<div></div>}
                <AddItemsButton
                  onClick={onContinueShopping}
                  style={{ height: "fit-content" }}
                >
                  <ButtonTitle>{Text.addMoreItems}</ButtonTitle>
                </AddItemsButton>
              </AddItemsContainer>
            )}
          </ProductDetail>
        )}
      </ProductDetailContainer>
    </ProductDetailMainContainer>
  );
};

const ProductDetailMainContainer = styled.div`
  flex-direction: column;
  display: flex;
  justify-content: center;
  @media only screen and (max-width: 576px) {
    display: none;
  }
`;
const ProductHeaderContainer = styled.div`
  display: flex;
  background-color: ${Colors.aqua};
  justify-content: center;
  /* margin-top: 2rem; */
  @media only screen and (max-width: 640px) {
    padding-right: 1rem;
    justify-content: space-between;
    // overflow-x: scroll;
  }
`;
const ProductDetailContainer = styled.div`
  display: flex;
  justify-content: center;
  @media only screen and (min-width: 1024px) {
    // overflow-y: scroll;
    // height: 20rem;
  }
  @media only screen and (max-width: 640px) {
    padding-right: 1rem;
  }
`;
const ProductHeader = styled.div`
  width: 64rem;
  display: flex;
  padding: 0rem;
  flex-direction: row;
  gap: 3.5rem;
  justify-content: flex-start;
  @media only screen and (max-width: 1024px) {
    gap: 3rem;
  }
  @media only screen and (max-width: 640px) {
    gap: 0rem;
    align-items: center;
  }
  @media only screen and (max-width: 300px) {
    gap: 1rem;
  }
`;
const ProductDetail = styled(ProductHeader)`
  background-color: ${Colors.white};
  display: flex;
  flex-direction: column;
  gap: 0rem;
  @media only screen and (max-width: 1024px) {
    gap: 0rem;
  }
  @media only screen and (max-width: 640px) {
    width: 100%;
  }
`;

const ProductTitles = styled.span`
  color: ${Colors.white};
  text-align: center;
  font-size: 1rem;
  font-weight: 400;
  text-transform: uppercase;
  width: 18%;
  @media only screen and (max-width: 640px) {
    width: 24%;
    font-size: 0.8rem;
  }
`;
const AddItemsContainer = styled.div`
  display: flex;
  justify-content: space-between;
  padding: 2.5rem 0;
  align-items: flex-end;
`;

const AddItemsButton = styled.button`
  background: ${Colors.white};
  outline: none;
  display: flex;
  padding: 12px 20px;
  justify-content: center;
  align-items: center;
  border-radius: 8px;
  border: 1px solid ${Colors.aqua};
  cursor: pointer;
`;
const ButtonTitle = styled.span`
  font-size: 1rem;
  font-weight: 900;
  text-align: center;
  color: ${Colors.aqua};
`;
export default ProductDetails;
